/* btg-showcase.js — By The Gaze
   Pinned category showcase, two phases as you scroll:
     1) the first category rises from the bottom-right into the centre;
     2) once centred (pinned), the categories scroll across (next enters from the right).
   Eased motion + gentle in-frame image parallax. Stacked fallback on small screens / reduced motion. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SMOOTH = 0.09; // lower = smoother / more glide
  var ENTER_X = 0.2; // hold this fraction of viewport WIDTH to the right while rising
  var ENTER_Y = 0.05; // start this fraction of viewport HEIGHT down (small rise = tight gap)
  var SCROLL_END = 0.72; // finish the horizontal scroll at this fraction of phase 2, then hold (dwell)

  function clamp(v, a, b) {
    return v < a ? a : v > b ? b : v;
  }

  function initShowcase(section) {
    if (section.dataset.showcaseReady === 'true') return;
    section.dataset.showcaseReady = 'true';

    var pin = section.querySelector('[data-showcase-pin]');
    var sticky = section.querySelector('[data-showcase-sticky]');
    var track = section.querySelector('[data-showcase-track]');
    if (!pin || !sticky || !track) return;
    var panels = Array.prototype.slice.call(track.querySelectorAll('[data-panel]'));
    if (!panels.length) return;

    var enabled = false;
    var curX = 0;
    var curY = 0;
    var tgX = 0;
    var tgY = 0;
    var rafId = null;

    function frame() {
      var vh = window.innerHeight;
      var vw = window.innerWidth || 1;
      var ph = pin.offsetHeight;
      // p spans the section's whole time on screen (0 entering bottom -> 1 leaving top)
      var p = ph > 0 ? clamp((vh - pin.getBoundingClientRect().top) / ph, 0, 1) : 0;
      // pc = progress at which the section is pinned / centred (its top reaches the viewport top)
      var pc = clamp(vh / ph, 0.001, 0.999);
      var maxX = track.scrollWidth - sticky.clientWidth;

      if (p < pc) {
        // Phase 1 — rise straight up on the RIGHT; no horizontal scroll yet
        var remain = 1 - p / pc; // 1 entering -> 0 risen
        tgX = vw * ENTER_X; // held to the right (does not drift toward centre)
        tgY = remain * vh * ENTER_Y; // down -> 0 (rises)
      } else {
        // Phase 2 — scroll horizontally; finish (2nd category centred) before the pin releases,
        // then hold it centred for a beat before the section scrolls away
        var s = (p - pc) / (1 - pc); // 0 (just reached middle) -> 1 end
        var sScroll = clamp(s / SCROLL_END, 0, 1); // completes at SCROLL_END, then dwells
        var startX = vw * ENTER_X;
        tgX = startX - sScroll * (startX + maxX);
        tgY = 0;
      }

      curX += (tgX - curX) * SMOOTH;
      curY += (tgY - curY) * SMOOTH;
      if (Math.abs(tgX - curX) < 0.4) curX = tgX;
      if (Math.abs(tgY - curY) < 0.4) curY = tgY;

      track.style.transform = 'translate3d(' + curX.toFixed(2) + 'px,' + curY.toFixed(2) + 'px,0)';

      // gentle in-frame image parallax (based on horizontal position)
      panels.forEach(function (panel, i) {
        var img = panel.querySelector('[data-showcase-img]');
        if (!img) return;
        var rel = i + curX / vw;
        img.style.transform = 'translateX(' + clamp(rel * -6, -6, 6).toFixed(2) + '%)';
      });

      rafId = curX !== tgX || curY !== tgY ? requestAnimationFrame(frame) : null;
    }
    function play() {
      if (enabled && rafId === null) rafId = requestAnimationFrame(frame);
    }

    function enable() {
      if (enabled) return;
      enabled = true;
      section.style.setProperty('--panels', panels.length);
      section.classList.add('is-pinned');
    }
    function disable() {
      if (!enabled) return;
      enabled = false;
      section.classList.remove('is-pinned');
      if (rafId) cancelAnimationFrame(rafId);
      rafId = null;
      curX = curY = tgX = tgY = 0;
      track.style.transform = '';
      panels.forEach(function (p) {
        var img = p.querySelector('[data-showcase-img]');
        if (img) img.style.transform = '';
      });
    }

    function setup() {
      if (!reduceMotion && window.innerWidth >= 990) {
        enable();
        play();
      } else {
        disable();
      }
    }

    setup();
    window.addEventListener('scroll', play, { passive: true });
    window.addEventListener('resize', function () {
      setup();
      play();
    });
  }

  function init() {
    Array.prototype.slice.call(document.querySelectorAll('.btg-showcase')).forEach(initShowcase);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
